export const environment = {
    production: false,
    API_BACK: 'https://panelcj2.altiacontroltower.com/api/',
    API_VERSION: 'v1'
};
